/*global Promise, clm, pModel, document, window */
var FakeCation = FakeCation || {};

(function (ns, clm, pModel) {
  "use strict";

  var ClmTracker = clm.tracker;

  function faceFeatureDetect(canvas, faceRectangle) {
    return new Promise(function (resolve, reject) {
      var target = document.createElement('canvas'),
          debugCtx, sourceCtx;

      var obj = {
        source: canvas,
        target: target,
        isRunning: false
      };

      sourceCtx = canvas.getContext('2d');

      obj.tracker = new ClmTracker({
        stopOnConvergence: true
      });
      obj.tracker.init(pModel);
      var _update = function () {
        obj.drawRequest = window.requestAnimationFrame(_update);
        var _pos = obj.tracker.getCurrentPosition();
        if (_pos) {
          obj.iterationPosition = _pos;
          debugCtx = ns.utils.dump(sourceCtx);
          obj.tracker.draw(debugCtx.canvas);
        }
      };

      obj.start = function (box) {
        console.log(box);
        this.tracker.start(this.source, box);
        _update();
      };

      function defaultResolve () {
        var w = canvas.width,
            h = canvas.height;

        console.log('defaultResolve');
        resolve([
          [10, 10],
          [w - 10, 10],
          [10, h/2|0],
          [w - 10, h/2|0],
          [w/2|0, 10]
        ]);
      }

      function trackLostHandler() {
        obj.tracker.stop();
        removeHandlers();
        console.log("tracker lost");
        // reject(); // instead of reject we use some border points
        defaultResolve();
      }

      function trackNotFoundHandler() {
        obj.tracker.stop();
        removeHandlers();
        console.log("The tracking had problems with finding a face in this image. Try selecting the face in the image manually.");
        // reject(); // instead of reject we use some border points
        defaultResolve();
      }

      function trackConvergedHandler() {
        removeHandlers();
        console.log("tracker done");
        obj.iterationPosition.push([obj.iterationPosition[14][0], faceRectangle[1]]);
        obj.iterationPosition.push([obj.iterationPosition[0][0], faceRectangle[1]]);
        resolve(obj.iterationPosition.map(point => [parseInt(point[0], 10), parseInt(point[1], 10)]));
      }

      function removeHandlers() {
        window.cancelAnimationFrame(obj.drawRequest);
        document.removeEventListener("clmtrackrLost", trackLostHandler, false);
        document.removeEventListener("clmtrackrNotFound", trackNotFoundHandler, false);
        document.removeEventListener("clmtrackrConverged", trackConvergedHandler, false);
      }

      document.addEventListener("clmtrackrLost", trackLostHandler, false);
      document.addEventListener("clmtrackrNotFound", trackNotFoundHandler, false);
      document.addEventListener("clmtrackrConverged", trackConvergedHandler, false);

      obj.start(faceRectangle);

    });
  }
  
  function findClickPoints(width, height, pt_left, pt_right, pt_bottom) {
    var center = [(pt_right[0] + pt_left[0]) / 2, (pt_right[1] + pt_left[1]) / 2];

    var d1 = ns.utils.distance(pt_left, pt_right);
    var d2 = ns.utils.distance(center, pt_bottom);

    function bounds(v_c, r, m) {
      var r1 = 0.4 * v_c + 0.4 * r;
      var r2 = 0.4 * (m - v_c) + 0.4 * r;
      return [r1, r2];
    }

    var bx = bounds(center[0], d1, width);
    d1 = Math.min(d1, bx[0]);
    d1 = Math.min(d1, bx[1]);

    var by = bounds(center[1], d2, height);
    d2 = Math.min(d2, by[0]);
    d2 = Math.min(d2, by[1]);

    // calculate the points of upper half ellipse
    var points = (function (c, a, b, n) {
        var pts = [];

        var step = Math.PI / n;

        var theta = Math.PI;

        var x, y;

        while (theta < 2 * Math.PI) {
          x = c[0] + a * Math.cos(theta);
          y = c[1] + b * Math.sin(theta);
          pts.push([x, y]);

          theta += step;
        }

        return pts;
      })(center, d1, d2 * 2, 20)
      .filter(function (p) {
        return p[0] >= 0 && p[0] < width && p[1] >= 0 && p[1] < height;
      });

    return points;
  }

  

  ns.faceFeatureDetect = faceFeatureDetect;
  ns.findClickPoints = findClickPoints;

}(FakeCation, clm, pModel));
